// Featured Market Hero event definitions for analytics.
// See `frontend/design/featured-market-hero.md` Layer 8 — Telemetry.

import type { EventDefinition } from './navigation';

export type FeaturedHeroSource = 'trending' | 'boosted' | 'editor';

export type FeaturedHeroCarouselTrigger = 'auto' | 'dot' | 'pill' | 'keyboard';

export type FeaturedHeroViewedProperties = {
  marketPubkey: string;
  slot: number;
  source: FeaturedHeroSource;
};

export type FeaturedHeroCardClickedProperties = {
  marketPubkey: string;
  outcomeIndex: number;
  outcomeLabel: string;
  slot: number;
};

export type FeaturedHeroThesisClickedProperties = {
  marketPubkey: string;
  thesisId: string;
  slot: number;
};

export type FeaturedHeroCarouselAdvancedProperties = {
  trigger: FeaturedHeroCarouselTrigger;
  fromSlot: number;
  toSlot: number;
};

export type FeaturedHeroShareOpenedProperties = {
  marketPubkey: string;
  slot: number;
};

export type FeaturedHeroBookmarkToggledProperties = {
  marketPubkey: string;
  saved: boolean;
  slot: number;
};

export const FEATURED_HERO_VIEWED: EventDefinition<FeaturedHeroViewedProperties> = {
  name: 'featured_hero_viewed',
};

export const FEATURED_HERO_CARD_CLICKED: EventDefinition<FeaturedHeroCardClickedProperties> = {
  name: 'featured_hero_card_clicked',
};

export const FEATURED_HERO_THESIS_CLICKED: EventDefinition<FeaturedHeroThesisClickedProperties> = {
  name: 'featured_hero_thesis_clicked',
};

export const FEATURED_HERO_CAROUSEL_ADVANCED: EventDefinition<FeaturedHeroCarouselAdvancedProperties> =
  {
    name: 'featured_hero_carousel_advanced',
  };

export const FEATURED_HERO_SHARE_OPENED: EventDefinition<FeaturedHeroShareOpenedProperties> = {
  name: 'featured_hero_share_opened',
};

export const FEATURED_HERO_BOOKMARK_TOGGLED: EventDefinition<FeaturedHeroBookmarkToggledProperties> =
  {
    name: 'featured_hero_bookmark_toggled',
  };
